// 메뉴 텍스트는 i18n(t)로 받고, 여기서는 라우트 정보만 정의합니다.
// 각 항목의 labelKey/translation key는 src/i18n/locales/{lang}.json 의 menu.* 참조.
export const MENU = [
  {
    labelKey: "menu.aboutUs",
    path: "/about/",
    hashId: "about",
    sub: [
      // About us: 새 회사소개 페이지(/about). 기존 CRO 중심 페이지는 /whoweare 로 남아 있습니다.
      { labelKey: "menu.sub.whoweare", path: "/about/", hashId: "about" },
      { labelKey: "menu.sub.heringsteam", path: "/heringsteam/", hashId: "heringsteam" },
      // IR 자료: 메뉴에서 숨김 (페이지와 라우트는 유지 — /irinformation/ 로 직접 접근 가능)
      // { labelKey: "menu.sub.ir", path: "/irinformation/", hashId: "irinformation" },
    ],
  },
  {
    labelKey: "menu.ourService",
    path: "/rpmsolution/",
    hashId: "rpmsolution",
    sub: [
      { labelKey: "menu.sub.rpm", path: "/rpmsolution/", hashId: "rpmsolution" },
      { labelKey: "menu.sub.healthcare", path: "/healthcare/", hashId: "healthcare" },
      { labelKey: "menu.sub.clinicalresearch", path: "/clinicalresearch/", hashId: "clinicalresearch" },
    ],
  },
  {
    labelKey: "menu.news",
    path: "/news/",
    hashId: "news",
    sub: [{ labelKey: "menu.news", path: "/news/", hashId: "news" }],
  },
  {
    labelKey: "menu.contactUs",
    path: "/contactus/",
    hashId: "contactus",
    sub: [{ labelKey: "menu.contactUs", path: "/contactus/", hashId: "contactus" }],
  },
];
